import * as d3 from "d3";
/**
 * 氨基酸工具
 * @author zhaoming
 */
const AACUtils = {
    _contentWidth: 860,
    /**
     * 蛋白质域颜色
     */
    domainColor: [
        "#DBAB99",
        "#92E1DD",
        "#CDAA43",
        "#094B6C",
        "#6BF28F",
        "#715506",
        "#E37056",
        "#EC2B00",
        "#CDB7E2",
        "#2491CE",
        "#05484B",
        "#24A148",
        "#FFDD81",
        "#CB2852",
        "#531491",
        "#0EBDBA",
        "#0F6027",
        "#C8970B",
        "#B03E13",
        "#852CDF",
        "#6488BC",
        "#05484B",
        "#DBF17C",
        "#405D90",
        "#FFCE95",
        "#B94362",
        "#34B6FF",
        "#935BC8",
    ],
    /**
     * snp&fusion (圆盘颜色)
     */
    discColorMap: {
        frameshift_variant: "#9B110E",
        inframe_deletion: "#EE588A",
        inframe_insertion: "#3B3EAC",
        missense_variant: "#008744",
        noncoding_variant: "#046C9A",
        nonframeshift_block_substitution: "#FAD510",
        protein_altering_variant: "#E58601",
        splice_site: "#EC0000",
        splice_region: "#CC6399",
        start_lost: "#6633CC",
        stop_gained: "#0057E7",
        stop_lost: "#0099C6",
        fusion: "#646464",
        other: "#66AA00",
        other1: "#F2AD00",
        other2: "#DD6E65",
        other3: "#921A5F",
        other4: "#9885CF",
        other5: "#11469D",
        other6: "#5BBCD6",
        other7: "#5574A6",
        other8: "#AAAA11",
    },
    /**
     * snp&fusion (圆盘颜色)
     */
    discColor: [
        "#FAD8CB",
        "#B94362",
        "#CDB7E2",
        "#DDF3FF",
        "#0EBDBA",
        "#DBF17C",
        "#FFE9CC",
        "#E37056",
        "#FFD3DF",
        "#935BC8",
        "#9DD1EC",
        "#CCE8E7",
        "#6BF28F",
        "#FFDD81",
        "#DBAB99",
        "#6488BC",
        "#F0E1FF",
        "#E999AE",
        "#A2DFDC",
        "#F4FFC9",
        "#C8AA55",
    ],
    //validate and email with regex and commit each line
    assJsonData(data) {
        let item = [];
        data.map((list, i) => {
            let newData = {};
            newData.label = list.name;
            newData.value = list.id * 1;
            newData.classes = list.classes;
            newData.children = list.children ? this.assJsonData(list.children) : [];
            item.push(newData);
        })
        return item;
    },
    /**
     * 获取鼠标滑动基因位点氨基酸数据
     * @param {当前节点数据} event 
     * @param {基础数据信息} accdata 
     * @param {矩形尺表距x轴位置} rectangleX 
     */
    getMoveTipInfo(event, accdata, rectangleX, sliderOffsetX) {
        let thatData = event.target.__data__;
        let moveOffsetx = 0;
        if (rectangleX == 0) {
            moveOffsetx = event.offsetX + sliderOffsetX - rectangleX;
        } else {
            moveOffsetx = event.offsetX + sliderOffsetX - Math.abs(rectangleX);
        }
        let multiple =
            thatData.nodeData.proportion / thatData.nodeData.siteLen;
        let movePosNum = Math.ceil(moveOffsetx / multiple);
        let moveChrPos = 0;
        let moveRNA = 0;
        if (accdata.direction == "+") { // 正链 RNA and chr Pos =>计算
            moveRNA = accdata.cdsPosition[0] - 1 + movePosNum;
            moveChrPos = thatData.nodeData.coding[0] +
                Math.ceil((moveOffsetx - thatData.x) / multiple) -
                1;
        } else { // 负链 RNA and chr Pos =>计算
            moveRNA = accdata.cdsPosition[0] - 1 + movePosNum;
            moveChrPos = thatData.nodeData.coding[1] -
                Math.ceil((moveOffsetx - thatData.x) / multiple) +
                1;
        }

        let res = {
            Exon: thatData.nodeData.exon,
            AA: Math.ceil(movePosNum / 3),
            RNA: moveRNA,
            Pos: moveChrPos,
            MoveOffsetx: moveOffsetx,
        };
        return res;
    },
    /**
     * 合成基础数据
     * @param {*} param 
     * @param {*} accstr 
     * @param {*} isoformData 
     * @param {*} contentWidth 
     * @returns 
     */
    compositeBaseData(param, accstr, isoformData, contentWidth = 860) {
        let that = this;
        that._contentWidth = contentWidth;
        let condingSite = that.codingSite(param, accstr);
        let res = that.genelookSite(isoformData, condingSite);
        return res;
    },
    /**
     * 基因外观位置
     * @param {*} param 
     * @param {*} accdata 
     */
    genelookSite(param, accdata) {
        let that = this,
            resData = accdata;
        resData.pdomain = [];
        let uidColor = that.setDomainColor(param.pdomains);
        param.pdomains.forEach((item, index) => {
            let json = item;
            //氨基酸x轴起始位置（转换为像素比例）=（氨基酸起始值-1）* 密码子倍数/氨基酸总长度*视觉显示盒模型宽度
            json.startX = (item.start - 1) * 3 / accdata.totalSite * that._contentWidth;
            //氨基酸长度（转换为像素比例）=（氨基酸结束值-氨基酸起始值+1）* 密码子倍数/氨基酸总长度*视觉显示盒模型宽度
            json.stopW = (item.stop - item.start + 1) * 3 / accdata.totalSite * that._contentWidth;
            json.color = item.color ? item.color : uidColor[item.cdd];
            resData.pdomain.push(json);
        });
        //去重 pdomain,cdd 为依据
        resData.pdomainFilter = resData.pdomain.filter((currentValue, currentIndex, sourceArr) => {
            return sourceArr.findIndex(x => x.cdd === currentValue.cdd) == currentIndex;
        })
        //颠倒顺序后的数组
        resData.pdomainFilter.reverse();
        return resData;
    },
    /**
     * 设置蛋白质结构域数据指定颜色
     * @param {蛋白质结构域数据源} pdomains 
     * @returns 
     */
    setDomainColor(pdomains) {
        let that = this, res = {};
        let uidColor = {};
        pdomains.forEach((item, index) => {
            if (res.hasOwnProperty(item.cdd)) {
                res[item.cdd].push(item);
            } else {
                res[item.cdd] = [];
                res[item.cdd].push(item);
            }

        });
        Object.keys(res).forEach((key, index) => {
            uidColor[key] = that.domainColor[index];
        });
        return uidColor;
    },
    /**
     * 是否为整数
     * @param {*} n 
     * @returns 
     */
    isInteger(n) {
        return parseInt(n) == parseFloat(n)
    },
    /**
    * too 氨基酸游标数据=>标尺
    * @param {*} cdslen 
    * @param {*} width 
    */
    getMinorTickToo(cdslen = 1359, width = 860) {
        let tick = 0;
        let size = cdslen / 3; // 氨基酸数
        let splitNumber = Math.floor(width / 100); //截取游标段
        let res = [];
        let linear = d3.scaleLinear().domain([0, size]);
        let linearTicks = linear.nice().ticks(splitNumber);
        let len = linearTicks.length;
        tick = linearTicks[1];
        for (let i = 1; i < len - 1; i++) {
            let obj = {};
            obj.minor = i * tick;
            obj.posMinor = obj.minor * 3;
            obj.powers = obj.posMinor / cdslen;
            obj.xMinor = obj.powers * width;
            res.push(obj);
        }
        return res;
    },
    /**
     * 获取蛋白质领域信息
     * @param {基础数据信息} param 
     * @param {当前鼠标位置} moveOffsetx 
     * @param {隐藏的蛋白质域} hiddenPdomain 
     * @returns 
     */
    getMovePdomainInfo(param, moveOffsetx, hiddenPdomain) {
        let temp = [];
        param.forEach(item => {
            let stop = item.startX + item.stopW;
            if (!hiddenPdomain.hasOwnProperty(item.name)) {
                if (moveOffsetx >= item.startX && moveOffsetx <= stop) {
                    temp.push(item);
                }
            }

        });
        return temp;
    },
    /**
     * 密码子位置
     * @param {*} param 
     */
    codingSite(param, accstr) {
        let that = this;
        let codingAry = param.showCoding; //param.showCoding;
        let start = param.start;
        let end = param.end;
        let tempAry = [];
        let resData = param;
        let totalLen = 0;
        let codingSiteStr = [];
        let startCodonFrameStr = '';
        codingAry.forEach((item, index) => {
            let siteBeginIndex = param.direction == "+" ? item[0] - start : end - item[1]; //注：负链=> siteBeginIndex=end-item[1]
            let siteLen = item[1] - item[0] + 1;
            let siteEndIndex = siteBeginIndex + siteLen;
            let json = {};
            json.siteStart = siteBeginIndex;
            json.siteLen = siteLen;
            json.siteStr = accstr.substring(siteBeginIndex, siteEndIndex);
            json.coding = item;
            json.direction = param.direction;
            json.exon = param.codonStartIndex + index;
            codingSiteStr.push(json.siteStr);
            totalLen += json.siteLen;
            tempAry.push(json)
        })
        resData.codingSite = this.rectWidth(tempAry, totalLen, that._contentWidth);
        resData.totalSite = totalLen;
        resData.codingSiteStr = codingSiteStr.join('');
        
        if(resData.startCdsFrame != 0){
            startCodonFrameStr =  resData.codingSiteStr.substring(resData.startCdsFrame);
            resData.transCodonData =  this.transCodon2AA(startCodonFrameStr);
        }else{
            resData.transCodonData = this.transCodon2AA(resData.codingSiteStr);
        }
        // resData.minorTick = this.getMinorTick(param.cdslen);
        resData.minorTick = this.getMinorTickToo(param.cdslen, that._contentWidth);
        return resData;
    },
    rectWidth(siteAry, siteSum, rw) {
        siteAry.forEach(item => {
            let temp = item.siteLen / siteSum
            item.proportion = rw * temp;
            item.powers = temp;
        })
        return siteAry;
    },
    /**
     * 逻辑梳理棒棒糖数据
     * @param {基础数据} codingSite 
     * @param {棒棒糖数据} bbdata 
     * @returns 
     */
    lollipopData(codingSite, bbdata, displayClasses = {}) {
        let res = Object.assign({}, bbdata);
        let snp = this.lollipopSnp(codingSite, bbdata.snp, displayClasses);
        let fusion = this.lollipopFusion(codingSite, bbdata.fusion, displayClasses.fusion);
        fusion.sort(this.compare('number', 'desc'));
        snp.sort(this.compare('number', 'desc'));
        let all = [...snp, ...fusion];
        let mapAll = this.posGroupNumberCount(this.groupingMap(all));
        res.snp = Object.assign([], snp);
        res.fusion = Object.assign([], fusion);
        res.allMap = mapAll.sort(this.compare('count', 'desc'))
        res.classes = this.setClssesColor(bbdata.classes);
        return res;
    },
    /**
     * set classes color 
     * @param {*} param 
     * @returns 
     */
    setClssesColor(param) {
        let $this = this;
        param.forEach((item, index) => {
            item.color = $this.discColorMap[item.name];
        })
        return param;
    },
    /**
     * SNP
     * @param {*} codingSite 
     * @param {*} param 
     * @returns 
     */
    lollipopSnp(codingSite, param, displayClasses) {
        let $this = this;
        let res = [];
        param.forEach((item, index) => {
            let jsonObj = {};
            if (displayClasses[item.consequence] == false) {
                jsonObj = {};
            } else {
                jsonObj = item;
                jsonObj.posX = $this.findPosX(codingSite, item.pos);
                jsonObj.color = $this.discColorMap[item.consequence];
                res.push(jsonObj)
            }

        });
        return res;
    },
    /**
     * fusion
     * @param {*} codingSite 
     * @param {*} param 
     * @returns 
     */
    lollipopFusion(codingSite, param, displayClasses) {
        let $this = this;
        if (displayClasses == false) {
            return [];
        } else {
            param.forEach((item, index) => {
                if (item.a.pos) {
                    item.key = 'a';
                    item.pos = item.a.pos;
                    item.gene = item.a.gene;
                    item.posX = $this.findPosX(codingSite, item.a.pos);
                    item.color = "#646464";
                } else {
                    item.key = 'b';
                    item.pos = item.b.pos;
                    item.gene = item.b.gene;
                    item.posX = $this.findPosX(codingSite, item.b.pos);
                    item.color = "#646464";
                }
            });
            return param;
        }

    },
    /**
     * 查找pos属于那个密码子组，同时计算x轴位置
     * @param {密码子域} codingSite 
     * @param {基因位点} pos 
     * @returns 
     */
    findPosX(codingSite, pos) {
        let that = this;
        let posX = 0;
        let len = codingSite.length;
        let temp = true;
        for (let i = 0; i < len; i++) {
            let item = codingSite[i];
            if (codingSite[i].direction == '-') { // 负链逻辑
                if (pos > codingSite[0].coding[1]) {
                    return 0;
                } else if (pos < codingSite[len - 1].coding[0]) {
                    return that._contentWidth;
                } else if (pos >= item.coding[0] && pos <= item.coding[1]) {
                    let x = (item.coding[1] - pos + 1) / item.siteLen * item.proportion;
                    posX += x;
                    return posX;
                } else if (pos > item.coding[1] && pos < codingSite[i - 1].coding[0]) {
                    return posX;
                } else {
                    posX += item.proportion
                }
            } else { // 正链逻辑
                if (pos < codingSite[0].coding[0]) {
                    return 0;
                } else if (pos > codingSite[len - 1].coding[1]) {
                    return that._contentWidth;
                } else if (pos >= item.coding[0] && pos <= item.coding[1]) {
                    let x = (pos - item.coding[0] + 1) / item.siteLen * item.proportion;
                    posX += x;
                    return posX;
                } else if (i != 0 && pos < item.coding[0] && pos > codingSite[i - 1].coding[1]) {
                    return posX;
                } else {
                    posX += item.proportion
                }
            }

        }
    },
    /**
     * pos值相同值为一组=>分组
     * @param {snp && fusion => data } param 
     * @returns 
     */
    posGroupNumberCount(param) {
        let res = [];
        Object.keys(param).forEach((key) => {
            let tmp = {};
            tmp.pos = key;
            tmp.count = this.getAttributeCount(param[key], 'number');
            // tmp.group = param[key];
            tmp.group = this.findIsMergeCells(param[key]);
            tmp.originalGroup = param[key];
            res.push(tmp);
        });
        return res;
    },
    /**
     *  查询需要合并的单元数据
     * @param {数据组} ary 
     * @param {限值} limits 
     * @returns 
     */
    findIsMergeCells(ary, limits = 9) {
        let res = [], tampMap = {};
        ary.forEach((item, index) => {
            let keyName = '';
            if (!item.hasOwnProperty(item.key)) {
                keyName = item.number;
            } else {
                keyName = item.number + item.key;
            }
            if (!tampMap.hasOwnProperty(keyName)) {
                tampMap[keyName] = [];
                tampMap[keyName].push(item);
            } else {
                tampMap[keyName].push(item);
            }
        });
        Object.keys(tampMap).forEach((key) => {
            if (tampMap[key].length > limits) {
                let tamp = this.mergeCells(tampMap[key]);
                res.push(tamp);
            } else {
                res.push(...tampMap[key]);
            }
        });
        res.sort(this.compare('number', 'desc'));
        return res;
    },
    /**
     * 执行合并单元
     * @param {*} param 
     * @returns 
     */
    mergeCells(param) {
        let json = param[0];
        let geneAry = [];
        param.forEach(item => {
            if (!item.hasOwnProperty(item.key)) {
                geneAry.push(item.aminoAcids);
            } else {
                if (json.key == 'a') {
                    geneAry.push(item.b.gene);
                } else {
                    geneAry.push(item.a.gene);
                }
            }
        });
        if (!json.hasOwnProperty(json.key)) {
            json.aminoAcidsAry = geneAry;
        } else {
            if (json.key == 'a') {
                json.b.geneAry = geneAry;
            } else {
                json.a.geneAry = geneAry;
            }
        }
        json.color = "#000000";
        return json;
    },
    /**
     * 获取特定属性统计
     * @param {对象组} ary 
     * @param {属性键} key 
     * @returns 
     */
    getAttributeCount(ary, key) {
        let res = 0;
        ary.forEach(item => {
            res += item[key];
        });
        return res;
    },
    /**
     * 根据pos值把pop入组 
     * @param { pop data} param 
     * @returns 
     */
    groupingMap(param) {
        let res = {};
        param.forEach((item, index) => {
            if (!res.hasOwnProperty(item.pos)) {
                res[item.pos] = [];
                res[item.pos].push(item);
            } else {
                res[item.pos].push(item);
            }
        })
        return res;
    },
    /**
     * 比较key值大小
     * @param {*} key 
     * @param {'asc','desc'} order 
     * @returns 
     */
    compare(key, order) {
        return (a, b) => {
            let val1 = a[key];
            let val2 = b[key];
            if (order == 'desc') {
                return val2 - val1;
            } else {
                return val1 - val2;
            }

        }
    },
    /**
     * 密码子转换成氨基酸序列
     * @param {*} accStr 密码子序列值 
     * @returns 
     */
    transCodon2AA(accStr) {
        let $this = this;
        let temp = "";
        let resultEnd = [];
        let codons = accStr.split("");
        let aacMap = $this.aacMap();
        codons.forEach(ele => {
            temp += ele;
            if (temp.length == 3) {
                if (aacMap.has(temp)) {
                    resultEnd.push(aacMap.get(temp));
                }
                temp = "";
            }
        });
        return resultEnd.join('');
    },
    /**
     * 密码子参考序列
     * @returns 
     */
    aacMap() {
        let tempMap = new Map();
        tempMap.set("GCG", "A");
        tempMap.set("GCA", "A");
        tempMap.set("GCC", "A");
        tempMap.set("GCT", "A");
        tempMap.set("TGC", "C");
        tempMap.set("TGT", "C");
        tempMap.set("GAC", "D");
        tempMap.set("GAT", "D");
        tempMap.set("GAG", "E");
        tempMap.set("GAA", "E");
        tempMap.set("TTC", "F");
        tempMap.set("TTT", "F");
        tempMap.set("GGG", "G");
        tempMap.set("GGA", "G");
        tempMap.set("GGC", "G");
        tempMap.set("GGT", "G");
        tempMap.set("CAC", "H");
        tempMap.set("CAT", "H");
        tempMap.set("ATA", "I");
        tempMap.set("ATC", "I");
        tempMap.set("ATT", "I");
        tempMap.set("AAG", "K");
        tempMap.set("AAA", "K");
        tempMap.set("TTG", "L");
        tempMap.set("TTA", "L");
        tempMap.set("CTG", "L");
        tempMap.set("CTA", "L");
        tempMap.set("CTC", "L");
        tempMap.set("CTT", "L");
        tempMap.set("ATG", "M");
        tempMap.set("AAC", "N");
        tempMap.set("AAT", "N");
        tempMap.set("CCG", "P");
        tempMap.set("CCA", "P");
        tempMap.set("CCC", "P");
        tempMap.set("CCT", "P");
        tempMap.set("CAG", "Q");
        tempMap.set("CAA", "Q");
        tempMap.set("CGG", "R");
        tempMap.set("CGA", "R");
        tempMap.set("CGC", "R");
        tempMap.set("CGT", "R");
        tempMap.set("AGG", "R");
        tempMap.set("AGA", "R");
        tempMap.set("TCG", "S");
        tempMap.set("TCA", "S");
        tempMap.set("TCC", "S");
        tempMap.set("TCT", "S");
        tempMap.set("AGC", "S");
        tempMap.set("AGT", "S");
        tempMap.set("ACG", "T");
        tempMap.set("ACA", "T");
        tempMap.set("ACC", "T");
        tempMap.set("ACT", "T");
        tempMap.set("GTA", "V");
        tempMap.set("GTC", "V");
        tempMap.set("GTT", "V");
        tempMap.set("TGG", "W");
        tempMap.set("TAC", "Y");
        tempMap.set("TAT", "Y");
        tempMap.set("GTG", "V");
        tempMap.set("TAA", "*");
        tempMap.set("TAG", "*");
        tempMap.set("TGA", "*");
        return tempMap;
    }
};

export default AACUtils;